
import  { getNodeRootStyleAttributeValue, getNodeStyleAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import  { AttributeFieldProps } from "./RenderAttributeInput";

import React from "react";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import SelectDropdown from "../SelectDropdown";
import { GetScreensizeIcon } from "../Icons/ScreenSizeIcons";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import HoverToolTip from "../HoverToolTip";

const verticalComponents = [wBComponentTypeNames.column,wBComponentTypeNames.tabContainer];

const horizontalOptions = [{label:"Auto",value:""},{label:"Left",value:"flex-start"},{label:"Center",value:"center"},{label:"Right",value:"flex-end"},{label:"Space Between",value:"space-between"},{label:"Space Around",value:"space-around"},{label:"Space Evenly",value:"space-evenly"}];
const verticalOptions = [{label:"Auto",value:""},{label:"Top",value:"flex-start"},{label:"Center",value:"center"},{label:"Bottom",value:"flex-end"},{label:"Space Between",value:"space-between"},{label:"Space Around",value:"space-around"},{label:"Space Evenly",value:"space-evenly"}];
export default function AlignmentField(props:AttributeFieldProps){

    const att = props.definition.attribute;
    const defaultDir:string = verticalComponents.includes(props.layoutObject.typename)?"column":"row";
    const rootFlexDir = getNodeRootStyleAttributeValue(props.layoutObject,props.screenSize,"flexDirection", defaultDir);
    const fallBackDir = getNodeRootStyleAttributeValue(props.layoutObject,props.screenSize-1,"flexDirection", defaultDir);
  
    const selectedDir = getNodeStyleAttributeValue(props.layoutObject,props.screenSize,attributeTypes.flexDirection);
    
    const [toggleState,setToggleState] = React.useState(false);

    const isRow = rootFlexDir.includes("row");//check include to catch row-reverse 
    if(isRow){
      if(att ==="alignHorizontal"||att==="justifyVertical")
        return null;
    }
    else{
    if(att ==="justifyHorizontal"||att==="alignVertical")
      return null;
    }
    
    let justifyVal = getNodeStyleAttributeValue(props.layoutObject,props.screenSize,attributeTypes.justifyContent);
    let alignVal = getNodeStyleAttributeValue(props.layoutObject,props.screenSize,attributeTypes.alignItems);

    let rootJustify = getNodeRootStyleAttributeValue(props.layoutObject,props.screenSize,attributeTypes.justifyContent,"center");
    let rootAlign = getNodeRootStyleAttributeValue(props.layoutObject,props.screenSize,attributeTypes.alignItems,"center");


    let xPos = 1;
    let yPos = 1;

    switch(justifyVal){
      case "":
        xPos = -1;
        break;

      case "flex-start":
        xPos = 0;
        break;
      case "center":
        xPos = 1;
        break;
      case "flex-end":
        xPos = 2;
        break;
      case "space-between":
        xPos = 3;
        break;
      case "space-around":
        xPos = 4;
        break;
      case "space-evenly":
        xPos = 5;
        break;
      default:
        break;

    }

    switch(alignVal){
      case "":
        yPos = -1;
        break;
      case "flex-start":
        yPos = 0;
        break;
      case "center":
        yPos = 1;
        break;
      case "flex-end":
        yPos = 2;
        break;
      case "space-between":
        yPos = 3;
        break;
      case "space-around":
        yPos = 4;
        break;
      case "space-evenly":
        yPos = 5;
        break;
      default:
        break;
      
    }

    if(!isRow){
      let temp = xPos;
      xPos = yPos;
      yPos = temp
    }

    const buttonMapping = [0,1,2,3,4,5,6,7,8];
    const updateByClick = (x:number,y:number)=>{

    
      let xClass = "center";
      let yClass = "center";
      if(x==0){
        xClass = "flex-start"
      }
      else if(x==2){
        xClass = "flex-end"
      }
      if(y==0){
        yClass = "flex-start"
      }
      else if(y==2){
        yClass = "flex-end"
      }

      if(!isRow){
        let temp = xClass;
        xClass = yClass;
        yClass = temp;
      }

      if(justifyVal == xClass&&alignVal==yClass){ // reclicking same box should reset to auto
        props.updateFunc(attributeTypes.justifyContent,"",props.definition.targetType);
        props.updateFunc(attributeTypes.alignItems,"",props.definition.targetType);
        props.updateFunc(attributeTypes.alignContent,"",props.definition.targetType);
      }
      else{

      props.updateFunc(attributeTypes.justifyContent,xClass,props.definition.targetType);
      props.updateFunc(attributeTypes.alignItems,yClass,props.definition.targetType);
      props.updateFunc(attributeTypes.alignContent,yClass,props.definition.targetType);
      }

      setToggleState(!toggleState);

    }

    const updateFlexDirection =(newDir:string)=>{

      if(selectedDir!=newDir){
        props.updateFunc(attributeTypes.flexDirection,newDir,props.definition.targetType);

        newDir = newDir==""?fallBackDir:newDir;
       
        if( rootFlexDir!=newDir){
            props.updateFunc(attributeTypes.justifyContent,alignVal,props.definition.targetType);
            props.updateFunc(attributeTypes.alignContent,justifyVal,props.definition.targetType);
            props.updateFunc(attributeTypes.alignItems,justifyVal,props.definition.targetType);

            // flip nested "autos" so that they only change their arrangement and not their alignment
            for(let i = props.screenSize+1;i<=ScreenSize.Mobile;i++){ 
                if(getNodeStyleAttributeValue(props.layoutObject,i,attributeTypes.flexDirection)==""){
                    let jVal = getNodeStyleAttributeValue(props.layoutObject,i,attributeTypes.justifyContent);
                    let aVal = getNodeStyleAttributeValue(props.layoutObject,i,attributeTypes.alignItems);

                    setNodeStyleAttributeValue(props.layoutObject,i,attributeTypes.justifyContent,aVal);
                    setNodeStyleAttributeValue(props.layoutObject,i,attributeTypes.alignContent,jVal);
                    setNodeStyleAttributeValue(props.layoutObject,i,attributeTypes.alignItems,jVal);
                  
             
                }
            }

            
        }
       
       
          setToggleState(!toggleState);
    }
  }

    return (
      <div className="wb-input-group">
 
        <label className={(justifyVal==""&&alignVal==""&&rootFlexDir=="")?"not-updated":"updated"}><span className="icon-label"><GetScreensizeIcon screenSize={props.screenSize}/>Align Content</span> </label>

        {/* <ButtonField {...props} updateFunc={(att:string,val:string,ttype:AttributeTargetType)=>{
          props.updateFunc(attributeTypes.flexDirection,val,ttype);
          setToggleState(!toggleState);
          
        }} definition={orderDef} label={""} /> */}
        <div className="w-full flex-row justify-between gap-small">
          <div className="flex-column justify-between" >
        <div className="alignment-grid">
    

          {
            buttonMapping.map((index)=>{
  
              let x = index%3;
              let y = Math.floor(index/3);
  
              return <button key={index} style={{gridArea: `${y+1}/${x+1}/${y+2}/${x+2}`}} 
              onClick={()=>{
                updateByClick(x,y);

              }}
              className={"invisible-button align-button align-button "+(x==xPos&&y==yPos?"selected":"")}>
              <AlignmentIcon isRow={isRow} x={x} y={y}/>
              </button>
  
            })
          }
          <div className="selected-alignment-icon" style={{pointerEvents:"none",gridArea:"1/1/4/4"}}>
            <AlignmentIconLarge justify={rootJustify} align={rootAlign} direction={isRow?"row":"column"} />
            </div>
          </div>
        </div>
        <div className="select-column flex-column h-full justify-between"  style={{width:"50%"}}>
         
          <>
          <div className="flex-row justify-between wb-input-row" >
            <button 
              onClick={()=>{
                updateFlexDirection("");
            }}
            className={(selectedDir==""?"selected":"")}
            style={{height:"32px"}} ><span className="font-small">Auto</span>
                 <HoverToolTip text={"Arrange Automatically"} />
            </button>


            <button style={{height:"32px"}}
               className={(selectedDir=="row"?"selected":"")}
              onClick={()=>{
                
                updateFlexDirection("row");
              }}
            > 
            <LeftRightArrow/>
            <HoverToolTip text={"Arrange Left to Right"} />
            </button>


            <button style={{height:"32px"}}
               className={(selectedDir=="column"?"selected":"")}
              onClick={()=>{
                updateFlexDirection("column");
            }}
            > <UpDownArrow/>
            <HoverToolTip text={"Arrange Top to Bottom"} />
            </button>
  
          </div>

          <div className="flex-row justify-between">
            <label>&nbsp;&nbsp;X:</label>
            <SelectDropdown key={(isRow?justifyVal:alignVal)+"select-horizontal"} options={horizontalOptions} defaultValue={(isRow?justifyVal:alignVal)} onChange={(val:string)=>{
              props.updateFunc((isRow?attributeTypes.justifyContent:attributeTypes.alignItems),val,props.definition.targetType);
              props.updateFunc((isRow?attributeTypes.justifyContent:attributeTypes.alignContent),val,props.definition.targetType);
              setToggleState(!toggleState);

            }}/>
          </div>
          <div style={{height:"1px",background:"#CDCDCD",width:"100%",margin:"6px 0px"}}></div>
          <div className="flex-row justify-between">
              <label>&nbsp;&nbsp;Y:</label>
              <SelectDropdown key={(isRow?alignVal:justifyVal)+"select-vertical"}  options={verticalOptions} defaultValue={(isRow?alignVal:justifyVal)} onChange={(val:string)=>{
              props.updateFunc((isRow?attributeTypes.alignItems:attributeTypes.justifyContent),val,props.definition.targetType);
              props.updateFunc((isRow?attributeTypes.alignContent:attributeTypes.justifyContent),val,props.definition.targetType);
              setToggleState(!toggleState);

              }}/>
          </div>
        </>
        </div>

        </div>
      </div>
  
  
    )

}


function AlignmentIconLarge({justify,align,direction}:{justify:string,align:string,direction:string}){
  
  let isRow = direction == "row";

  let shortSize = "10px";
  let longSize = "18px";
  return <div 
     style={{
      justifyContent:justify,
      alignItems:align,
      flexDirection:direction as any,
      display:"flex",
     gap:"1px",
     padding:"8px",
  
      position:"relative",
   
      zIndex:10

     }}
     className={"w-full h-full "}>
    <div className={"alignment-dot-large "} style={(isRow?{height:shortSize}:{width:shortSize})} ></div>
    <div className={"alignment-dot-large"} style={(isRow?{height:longSize}:{width:longSize})} ></div>
    <div className={"alignment-dot-large "} style={(isRow?{height:shortSize}:{width:shortSize})} ></div>

  </div>

}

function AlignmentIcon({x,y,isRow,extraDotClass}:{x:number,y:number,isRow?:boolean,extraDotClass?:string}){

  if(!extraDotClass)
    extraDotClass = "";

  let xClass = "-center";
  let yClass = "-center";

  
  if(x==0){
    xClass = "-start"
  }
  else if(x==2){
    xClass = "-end"
  }
  if(y==0){
    yClass = "-start"
  }
  else if(y==2){
    yClass = "-end"
  }

  if(isRow){
    xClass= "justify"+xClass;
    yClass = "align"+yClass;
  }
  else{
    xClass= "align"+xClass;
    yClass = "justify"+yClass;
  }

  const radius = "4px";
  const solidBorder = "1px solid #aaa";
  let passiveBorder ="1px solid white";// "1px solid var(--input-border)"



  let leftBorder = x == 0?solidBorder:passiveBorder;
  let rightBorder = x == 2?solidBorder:passiveBorder;
  let topBorder = y == 0?solidBorder:passiveBorder;
  let bottomBorder = y == 2?solidBorder:passiveBorder;

  let trRadius = x == 2&&y==0?radius:"0";
  let tlRadius = y == 0&&x==0?radius:"0";
  let brRadius = y == 2&&x==2?radius:"0";

  let blRadius = x == 0&&y==2?radius:"0";

  
  //let border = `${topBorder} ${rightBorder} ${bottomBorder} ${leftBorder}`;
  
  let flexClass = (isRow)?"flex-row":"flex-column";
  let shortSize = "10px";
  let longSize = "18px";

  return <div style={{

    borderRadius:`${tlRadius} ${trRadius} ${brRadius} ${blRadius}`,
    borderRight:rightBorder,
    borderLeft:leftBorder,
    borderTop:topBorder,
    borderBottom:bottomBorder,
    gap:"1px",
     padding:"8px"}} 
     
     className={"a-icon w-full h-full "+xClass+" "+yClass+" "+flexClass }>
    <div className={"alignment-dot "+(extraDotClass??"")} style={(isRow?{height:shortSize}:{width:shortSize})} ></div>
    <div className={"alignment-dot "+(extraDotClass??"")} style={(isRow?{height:longSize}:{width:longSize})} ></div>
    <div className={"alignment-dot "+(extraDotClass??"")} style={(isRow?{height:shortSize}:{width:shortSize})} ></div>

  </div>

}

function LeftRightArrow(){
  return <svg xmlns="http://www.w3.org/2000/svg"  height={"1em"} fill="currentColor" viewBox="0 0 448 512"><path d="M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-96L40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l184 0 0-96c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l160 160z"/></svg>
  //return <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColor" viewBox="0 0 512 512"><path d="M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"/></svg>
}

function UpDownArrow(){
  return <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColor" viewBox="0 0 384 512"><path d="M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l96 0 0-184c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 184 96 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-160 160z"/></svg>
 // return <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColor" viewBox="0 0 256 512"><path d="M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"/></svg>
}